import { Menu, MenuItem } from '@mui/material';
import React from 'react';

const EventChipMenu = ({ chipMenu, handleClose, onDeleteClick }) => {
  return (
    <Menu
      id="basic-menu"
      anchorReference="anchorPosition"
      anchorPosition={
        Boolean(chipMenu.position) ? { top: chipMenu.position.mouseY, left: chipMenu.position.mouseX } : undefined
      }
      open={Boolean(chipMenu.position)}
      onClose={handleClose}
    >
      <MenuItem onClick={onDeleteClick}>Törlés</MenuItem>
    </Menu>
  );
};

export default EventChipMenu;
